import { render, staticRenderFns } from "./CollectionAdnProcess.vue?vue&type=template&id=71d34bd3&scoped=true&"
import script from "./CollectionAdnProcess.vue?vue&type=script&lang=js&"
export * from "./CollectionAdnProcess.vue?vue&type=script&lang=js&"
import style0 from "./CollectionAdnProcess.vue?vue&type=style&index=0&id=71d34bd3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d34bd3",
  null
  
)

export default component.exports